const messages = {
    en: {
        login: "Login",
        clearValues: "Clear",
        emailAddress: "E-mail address",
        password: "Password",
        repeatpassword: "Repeat password",
        thanksforregistration: "Thank you for registering!",
        forgotpassword: "Forgot password?",
        senddata: "Send password",
        emailIssue: "Invalid email address",
        required: "Required",
        signup: "Signup"
    },
    ru: {
        login: "Логин",
        clearValues: "Oчистить формy",
        emailAddress: "Адрес электронной почты",
        password: "Пароль",
        repeatpassword: "Повторите пароль",
        thanksforregistration: "Спасибо за регистрацию!",
        forgotpassword: "Забыл пароль?",
        senddata: "Отправить пароль",
        emailIssue: "Неверный адрес электронной почты",
        required: "Обязательное поле",
        signup: "3арегистрироваться"
    }
  };

  export default messages;
